/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';
import { useTheme } from '@coursera/cds-core';

const styles = {
  itemRubricPanelContainer: (theme: Theme) => css`
    background-color: var(--cds-color-white-0);
    width: 100%;
    overflow: auto;
    flex-grow: 1;
  `,
};

type Props = {
  children?: React.ReactNode;
};

const RightPanel: React.FC<Props> = ({ children }) => {
  const theme = useTheme();
  return (
    <div css={styles.itemRubricPanelContainer(theme)} data-testid="right-panel-parent-container">
      {children}
    </div>
  );
};

export default RightPanel;
